import { render, staticRenderFns } from "./Praise.vue?vue&type=template&id=5f519d21&scoped=true"
import script from "./Praise.vue?vue&type=script&lang=js"
export * from "./Praise.vue?vue&type=script&lang=js"
import style0 from "./Praise.vue?vue&type=style&index=0&id=5f519d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f519d21",
  null
  
)

export default component.exports